// app/stores/localesStore.ts

import postUiService from "~/src/post/infrastructure/ui-services/postUiService";
import { useCompetitionStore } from "~/app/stores/competitionStore";

export const useLocalesStore = defineStore("localesStore", () => {
  const { getAllRegionsAvailableNewsLocales } = postUiService();
  const competitionStore = useCompetitionStore();

  const allRegionsAvailableNewsLocales = ref<{ [key: string]: string[] }>();
  const currentRegionAvailableNewsLocales = ref<string[] | undefined>();

  const findCurrentRegionLocales = () => {
    if (!!allRegionsAvailableNewsLocales.value && competitionStore.region?.id) {
      const stringRegionId = competitionStore.region.id.toString();
      return allRegionsAvailableNewsLocales.value[stringRegionId];
    } else {
      return undefined;
    }
  };

  const initializeLocalesStore = async () => {
    allRegionsAvailableNewsLocales.value = await getAllRegionsAvailableNewsLocales();
    currentRegionAvailableNewsLocales.value = findCurrentRegionLocales();
  };

  return {
    currentRegionAvailableNewsLocales,
    allRegionsAvailableNewsLocales,
    initializeLocalesStore,
  };
});
